import { useState } from 'react';
import html2canvas from 'html2canvas';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme.ts';

export const SIGNATURE_FONT_FAMILIES = ['Caveat', 'Pacifico', 'Marck Script', 'Meddon'];

const PEN_COLOR = defaultTheme.v3.colors.black[0];

export const useSignatureGenerator = () => {
	const [selectedFont, setSelectedFont] = useState<string>(SIGNATURE_FONT_FAMILIES[0]);
	const [signatureText, setSignatureText] = useState<string>();

	const getSignatureImageUrl = async () => {
		if (!signatureText) {
			return;
		}

		const tempDiv = document.createElement('div');
		tempDiv.style.fontFamily = selectedFont;
		tempDiv.style.color = PEN_COLOR;
		tempDiv.style.fontSize = '1.5rem';
		tempDiv.style.fontWeight = '700';
		tempDiv.style.width = 'fit-content';
		tempDiv.style.lineHeight = '3rem';
		tempDiv.style.padding = '0 1rem';
		tempDiv.style.position = 'fixed';
		tempDiv.style.top = '-9999px';
		tempDiv.innerText = signatureText;

		document.body.appendChild(tempDiv);

		const canvas = await html2canvas(tempDiv, { backgroundColor: null });
		return canvas.toDataURL('image/png');
	};

	return {
		selectedFont,
		setSelectedFont,
		signatureText,
		setSignatureText,
		getSignatureImageUrl,
	};
};
